module.exports = __webpack_public_path__ + "img/_spain.e5bdb957.png";